var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamtLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.955 11.625c.122.122.366.284.772.528v1.463l4.872 2.843v-.69c1.462.65 2.599 1.056 3.41 1.178h.041l-2.07 1.178-7.025-4.103v-2.397zm7.025-9.75l7.024 4.063v6.175c.69.487 1.259 1.096 1.746 1.828-.122-.041-.365-.163-.73-.325.446 1.015.527 2.559-1.138 2.925-3.979.934-9.176-1.666-11.125-2.966 1.015.406 1.949.772 2.842 1.056v-.65a18.817 18.817 0 01-4.304-2.153C2.671 10.731 1.412 9.391 1.25 9.147c.284.081.487.122.69.122-.609-1.097.04-2.275 1.056-2.722v-.61L9.98 1.875zm0 .853L3.727 6.344v2.925c-.284-.244-.69-.935-.772-1.34-.284.202-.324.608-.162 1.055.73 1.87 3.817 3.86 5.766 4.916V8.944H5.513L4.458 6.547h11.044l-1.056 2.437h-3.045v6.379c.893.162 1.746.284 2.517.325 3.37.162 3.614-.813 3.046-1.626l-1.95 1.138c-.527.04-1.015.04-1.461-.04l2.68-1.544V6.344L9.98 2.728z",
    fill: "url(#teamt-logo_svg__paint0_linear_4038_15688)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.955 11.625c.122.122.366.284.772.528v1.463l4.872 2.843v-.69c1.462.65 2.599 1.056 3.41 1.178h.041l-2.07 1.178-7.025-4.103v-2.397zm7.025-9.75l7.024 4.063v6.175c.69.487 1.259 1.096 1.746 1.828-.122-.041-.365-.163-.73-.325.446 1.015.527 2.559-1.138 2.925-3.979.934-9.176-1.666-11.125-2.966 1.015.406 1.949.772 2.842 1.056v-.65a18.817 18.817 0 01-4.304-2.153C2.671 10.731 1.412 9.391 1.25 9.147c.284.081.487.122.69.122-.609-1.097.04-2.275 1.056-2.722v-.61L9.98 1.875zm0 .853L3.727 6.344v2.925c-.284-.244-.69-.935-.772-1.34-.284.202-.324.608-.162 1.055.73 1.87 3.817 3.86 5.766 4.916V8.944H5.513L4.458 6.547h11.044l-1.056 2.437h-3.045v6.379c.893.162 1.746.284 2.517.325 3.37.162 3.614-.813 3.046-1.626l-1.95 1.138c-.527.04-1.015.04-1.461-.04l2.68-1.544V6.344L9.98 2.728z",
    fill: "#CDDCFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "teamt-logo_svg__paint0_linear_4038_15688",
    x1: 4.65,
    y1: 20.2,
    x2: 16.822,
    y2: 0.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.049,
    stopColor: "#AF893D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    stopColor: "#D29D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#FFCC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#E8B55D"
  })))));
}
export default __webpack_public_path__ + "static/svg/teamt-logo.svg";
export { SvgTeamtLogo as ReactComponent };